import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is it paper or digital?',
  a: 'It is a 100% digital product (High-Resolution PDF) optimized for iPad, Tablet, Laptop, and Smartphone. You can access it instantly and take it with you to any class.'
}, {
  q: 'Do I need experience working with seniors?',
  a: 'No. The system is designed for both beginners and experienced fitness professionals. It provides the foundational knowledge you need to start safely.'
}, {
  q: 'Does it work for group classes?',
  a: 'Yes. The classes, programs, and templates are designed for both individual personal training and large group environments.'
}, {
  q: 'Can I use it in community centers and senior facilities?',
  a: 'Absolutely. The system was created specifically for real-world senior fitness environments, including community centers, YMCAs, and assisted living facilities.'
}, {
  q: 'How quickly will I see results?',
  a: 'Most professionals report saving several hours of planning time during their very first week, and notice improved participant engagement immediately.'
}, {
  q: 'Are the exercises safe for all mobility levels?',
  a: 'Yes. The Movement Library includes progressions and regressions for every exercise, including seated chair options for participants with limited mobility.'
}, {
  q: 'Is this a one-time payment or a subscription?',
  a: 'It is a one-time payment of $27. You get lifetime access to the entire FITNESS SENIOR READY™ system and all 5 bonuses with no recurring fees.'
}, {
  q: 'Can I print the materials?',
  a: 'Yes, all guides, templates, and session plans are printer-friendly. Many instructors print the Session Builder System and keep it in a binder.'
}, {
  q: 'Do I get access to the bonuses immediately?',
  a: 'Yes! All 5 premium bonuses are included with your purchase today and will be delivered instantly alongside the main system.'
}, {
  q: 'What is the refund process if I am not satisfied?',
  a: 'Simply email us within 7 days of your purchase, and we will issue a full, no-questions-asked refund. Your investment is 100% risk-free.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 px-4 sm:px-6 bg-ivory" data-id="element-38">
      <div className="text-center mb-10" data-id="element-39">
        <h2 className="text-3xl sm:text-4xl font-heading font-bold text-petrol mb-3 leading-tight uppercase" data-id="element-40">
          FREQUENTLY ASKED QUESTIONS
        </h2>
      </div>

      <div className="flex flex-col gap-3 max-w-3xl mx-auto" data-id="element-41">
        {faqs.map((faq, i) => <div key={i} className="bg-cream border border-gold/30 rounded-lg overflow-hidden shadow-sm" data-id="element-42">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-gold/5 transition-colors gap-4" data-id="element-43">
              <span className="font-bold text-petrol text-base sm:text-lg leading-tight font-body" data-id="element-44">
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-sage transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-45" />
            </button>

            {openIndex === i && <div className="px-5 pb-5 pt-0 text-graphite text-sm sm:text-base leading-relaxed" data-id="element-46">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}